// GET /api/beta/auth/access-challenge. Read once when the door enters a
// challenge (login answered 409 or 428, or the Discord callback came back
// with a challenge status). No retry on 4xx: an expired challenge cookie is
// a real answer, not a blip, and the door says so.
import { useQuery } from '@tanstack/react-query';
import { getAccessChallenge } from '../endpoints';
import { queryKeys } from '../queryKeys';
import type { AccessChallenge } from '../types';
import { queryRetry } from './shared';

export function useAccessChallenge(enabled: boolean) {
  return useQuery<AccessChallenge>({
    queryKey: queryKeys.accessChallenge(),
    queryFn: ({ signal }) => getAccessChallenge(signal),
    enabled,
    retry: queryRetry,
    staleTime: 0,
    gcTime: 0,
  });
}
